import { render } from "./Complains.vue?vue&type=template&id=9c00e3e2&scoped=true"
import script from "./Complains.vue?vue&type=script&lang=js"
export * from "./Complains.vue?vue&type=script&lang=js"

import "./Complains.vue?vue&type=style&index=0&id=9c00e3e2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9c00e3e2"

export default script